import { useCallback, useEffect } from "react";
import type { TFunction } from "i18next";
import type { Destination } from "@whatslly/types/messages-server/destinations";
import type { DestinationsStore } from "../DestinationsStore";

export const useDestinationTestConnectionSubmit = <TResult extends Destination>({
  getFormValues,
  validate,
  onSubmitForm,
  store,
  t,
}: {
  getFormValues: () => TResult;
  validate: (values: TResult["settings"]) => Promise<unknown>;
  onSubmitForm: (data: TResult) => void;
  store: DestinationsStore;
  t: TFunction;
}) => {
  useEffect(() => {
    void validate(getFormValues().settings);
  }, [getFormValues, validate]);

  return useCallback(async () => {
    store.testConnection(t, getFormValues());
    const res = await store.testConnectionPromise;
    if (res?.success) {
      onSubmitForm(getFormValues());
    }
  }, [getFormValues, onSubmitForm, store, t]);
};
